import { Guid, Nillable } from '@web/utils';
import { OrderStatus } from '../../shared/enums';
import { PublicOrderBillingAddress } from './public-order-billing-address';
import { PublicOrderItem } from './public-order-item';
import { PublicOrderPayment } from './public-order-payment';
import { PublicOrderShipment } from './public-order-shipment';
import { OrderNumber } from '../../shared/types';
import { PublicOrderInvoice } from './public-order-invoice';
import { OrderRefundCollectionItem, RefundSummary } from '../../shared/models';

export class PublicOrderDetails {
  public constructor(
    private readonly data: {
      id: Guid;
      number: OrderNumber;
      status: OrderStatus;
      totalPrice: number;
      refundSummary?: Nillable<RefundSummary>;
      totalItems: number;
      createdAt: Date;
      comment?: Nillable<string>;
      billingAddress: PublicOrderBillingAddress;
      items: PublicOrderItem[];
      payments: PublicOrderPayment[];
      shipments: PublicOrderShipment[];
      invoice?: Nillable<PublicOrderInvoice>;
      temporaryInvoice?: Nillable<PublicOrderInvoice>;
      refunds: OrderRefundCollectionItem[];
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get number(): OrderNumber {
    return this.data.number;
  }

  public get status(): OrderStatus {
    return this.data.status;
  }

  public get totalPrice(): number {
    return this.data.totalPrice;
  }

  public get refundSummary(): Nillable<RefundSummary> {
    return this.data.refundSummary;
  }

  public get totalItems(): number {
    return this.data.totalItems;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get comment(): Nillable<string> {
    return this.data.comment;
  }

  public get billingAddress(): PublicOrderBillingAddress {
    return this.data.billingAddress;
  }
  public get items(): PublicOrderItem[] {
    return this.data.items;
  }

  public get payments(): PublicOrderPayment[] {
    return this.data.payments;
  }

  public get shipments(): PublicOrderShipment[] {
    return this.data.shipments;
  }

  public get invoice(): Nillable<PublicOrderInvoice> {
    return this.data.invoice;
  }

  public get temporaryInvoice(): Nillable<PublicOrderInvoice> {
    return this.data.temporaryInvoice;
  }

  public get refunds(): OrderRefundCollectionItem[] {
    return this.data.refunds;
  }
}
